export default class LogScreen {

  constructor() {
    this.logScreen = document.getElementById('log_screen');
    this.logScreen && this.init()
  }

  init() {
    window.setInterval(() => {
      this.logScreen.contentWindow.scrollTo( 0, 999999 );
    }, 2000);

    this.logScreen.addEventListener('load', () => {
      $(this.logScreen).contents().find('body').css({
        'font-family': '"Inter", "Roboto", "Arial", sans-serif',
        'font-size': '0.8125rem',
        'overflow-wrap': 'break-word',
      });
      window.location = this.logScreen.dataset.forwardToUrl;
    });
  }
}
